import { render, staticRenderFns } from "./WeekPlan.vue?vue&type=template&id=39cd6713&"
import script from "./WeekPlan.vue?vue&type=script&lang=js&"
export * from "./WeekPlan.vue?vue&type=script&lang=js&"
import style0 from "./WeekPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
